const initialState = {
  resultsAccountsPropertiesList: [],
  loading: false,
  resultsAccountsProperties: {},
  accountsPropertiesUpdateResponse: null,
  resultsAccountsPropertiesDelete: {},
  accountsPropertiesAddResponse: {},
  accountsPropertiesEditResponse: {}

};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_ACCOUNT_PROPERTIES_RESPONSE_GET":
      newState.resultsAccountsPropertiesList = action.value;
      newState.loading = false
      break;
    case "ACCOUNT_PROPERTIES_RESPONSE_GET":
      newState.resultsAccountsProperties = action.value
      newState.loading = false
      break

    case "ACCOUNT_PROPERTIES_RESPONSE_UPDATE":
      return {
        ...state,
        loading: false,
        accountsPropertiesUpdateResponse: action.value,
        error: action.value.responseStatus === "error" ? action.value : null,
      }

    case "ACCOUNT_PROPERTIES_RESPONSE_EDIT":
      newState.accountsPropertiesEditResponse = action.value
      newState.resultsAccountsPropertiesList = action.value
      newState.loading = false
      break

    case "RESET_ACCOUNT_PROPERTIES_RESPONSES":
      return {
        ...state,
        resultsAccountsPropertiesList: [],
        accountsPropertiesUpdateResponse: null,
        resultsAccountsPropertiesDelete: {},
        resultsAccountsProperties: {},
        accountsPropertiesAddResponse: {},
        accountsPropertiesEditResponse: {},
        error: null,
      }

    case "ACCOUNT_PROPERTIES_RESPONSE_DELETE":
      newState.resultsAccountsPropertiesDelete = action.value;
      break;
    case "ACCOUNT_PROPERTIES_RESPONSE_ADD":
      newState.accountsPropertiesAddResponse = action.value;
      break;



    case "CLEAR_ACCOUNT_PROPERTIES":
      return {
        ...state,
        resultsAccountsProperties: null,
      }
    default:
      break;
  }
  return newState;
}

export default reducer;
